// GridSlider.js
import { tns } from 'tiny-slider/src/tiny-slider';

class GridSlider {
	constructor(wrapper) {
		this.wrapper = wrapper;
		if (this.wrapper) {
			this.sliderEl = this.wrapper.querySelector('.block-grid__slider');
			this.initSlider();
		}
	}

	initSlider() {
		this.slider = tns({
			container: this.sliderEl,
			items: 1,
			slideBy: 'page',
			autoplay: true,
			autoplayButtonOutput: false,
			controls: true,
			nav: false,
			autoplayTimeout: 20000,
			speed: 300,
			loop: true,
			gutter: 0,
			mode: 'carousel',
			center: true, 
			prevButton: this.wrapper.querySelector('.block-grid__slider-prev'),
			nextButton: this.wrapper.querySelector('.block-grid__slider-next'),
		});
	}
}

export default GridSlider;
